import { DOCUMENT_METADATA_FIELDS } from '~/constants/conversationModels';
import { keyBy, map, merge } from 'lodash';

// create a new object that maps the label-value key pairs
const mapMetadataFields = (metadataDocument) =>
  Object.entries(DOCUMENT_METADATA_FIELDS)
    .filter(([key]) => Object.keys(metadataDocument).includes(key))
    .reduce((array, [key]) => {
      if (!metadataDocument[key]) return array;

      const newObj = {
        label: DOCUMENT_METADATA_FIELDS[key],
        value: metadataDocument[key],
      };

      return [...array, newObj];
    }, []);

export const getAllMetadataFields = (metadataDocument) => {
  const fields = mapMetadataFields(metadataDocument);
  const customFields = metadataDocument.customDisplayFields || [];
  return [...fields, ...customFields];
};

// merge metadata,thumbs, favoriteDocumentsIds preserving the order of the elements from the third one
export const mergeDocumentData = (metadata, thumbs, documentIds) => {
  const keyedArray1 = keyBy(metadata, 'externalId');
  const keyedArray2 = keyBy(thumbs, 'documentId');

  return map(documentIds, (id) => {
    return merge({}, keyedArray1[id], keyedArray2[id]);
  }).filter((doc) => Object.keys(doc).length > 0);
};
